module.exports = __webpack_public_path__ + "img/Renkaatalle-rengasvalinta_finnish.638ab4bf.png";